import React, {
  useState,
  useEffect,
  useImperativeHandle,
  useMemo
} from "react";
import { Button, Modal, Input, message } from "@cloud/atom-ui";
import { useDispatch } from "redux-react-hook";
import { i18n } from "@src/utils/i18n";
import history from "@src/utils/history";
import * as nls from "./nls";
import * as actions from "@src/actions/index";
import "./index.less";
import Assembly from "@src/components/Assembly-v2/index.js";
import {
  editApp,
  deleteApp,
  resetSecret,
  getAdministrators,
  getAppRole,
  appOnshelfStatus
} from "./thunk.js";
import { getAppInfoList } from "../../thunk";
import { innter, getItemByKey, setItemByKey } from "./init.js";
import useMappedState from "@src/utils/useMappedState";
import { Prompt } from "@src/components/ReactRouterPrompt";
import VersionTip from "../../components/version-tip";
import { getAppPathFromType, APP_TYPE } from "@src/utils/common";
import {urlDomainDeal} from "@src/utils/common";

const I18N = i18n(nls);
const text = I18N;
export default props => {
  const { tenant = {}, user, routeFlag, changeRouter } = useMappedState("root");
  const dispatch = useDispatch();
  const { authUrl = "" } = tenant;
  const {
    match: {
      params: { type: paramsType }
    }
  } = props;
  const urlPrefix = `/${paramsType}/appdetailV2`;
  const {
    history: {
      queryParams: {
        query: { id = 0, type = APP_TYPE.innerapp }
      }
    }
  } = props;

  const [visible, setVisible] = useState(false); // Modal的显示和隐藏
  const [visibleDelete, setVisibleDelete] = useState(false); // 删除弹框的显示和隐藏
  const [visibleCancle, setVisibleCancle] = useState(false); // 取消弹框的显示和隐藏
  const [visibelReset, setVisibleReset] = useState(false); // 重置二次确认;
  const [inputValue, setInputValue] = useState(""); // input框输入值
  const [appName, setAppName] = useState(""); // 应用名称
  const [isOnshelf, setIsOnshelf] = useState(false); // 是否上架
  const [adminListModalVisible, setAdminListModalVisible] = useState(false); //  管理员列表modal框显示
  const [administratorList, setAdministratorList] = useState([]); // 管理员列表
  const [role, setRole] = useState(1); // 默认给1, 表示开发者; 其他为协同开发者 没有修改和重置的权限
  const [leaveStatus, setleaveStatus] = useState(""); // 离开的跳转地址
  const [flag, setFlag] = useState(true); // 返回二次操作
  const [uploadStatus, setuploadStatus] = useState(false);
  const [backNoFresh, setBackNoFresh] = useState(false); // 点击侧边导航页面不刷新
  const {
    history: {
      queryParams: {
        query: { edit = "0" }
      }
    }
  } = props;
  const blankWord = "--";
  const [wecodeData, setWeCodeData] = useState(() => {
    return [...innter].filter(item => {
      if (paramsType == APP_TYPE.isv) {
        // 第三方应用隐私地址必填
        if (item.key === "privacyLinkCn" || item.key === "privacyLinkEn") {
          item.require = true;
        }
      }
      return item.appIncludes.includes(paramsType);
    });
  });
  const [isEdit, setIsEdit] = useState(false);
  useImperativeHandle(
    props.cref,
    () => {
      return {
        _childFn() {
          editHandle(2);
        }
      };
    },
    [isEdit]
  );

  const editBaseInfo = () => {
    if (isOnshelf) {
      if (user.isAdmin) {
        // 如果是管理员,可以直接去修改
        if (authUrl) {
          window.open(`${authUrl}`, "_blank");
        } else {
          message.error("当前租户没有绑定华为云账户，请先完成绑定！", 2);
        }
      } else {
        // 非管理员, 要联系管理员修改
        setAdminListModalVisible(true);
        if (!administratorList.length) {
          getAdministrators(id).then(result => {
            if (result && result.status === 1 && result.data) {
              setAdministratorList(result.data.contactUserVOS);
            } else {
              message.error(result.errMsg || "后台返回失败", 2);
            }
          });
        }
      }
    } else {
      const {
        history: {
          queryParams: {
            query: { id }
          }
        }
      } = props;
      history.push(`${urlPrefix}/baseInfo?id=${id}&edit=1&type=${paramsType}`);
    }
  };
  const editHandle = handleType => {
    switch (handleType) {
      case 0:
        let _this = this;
        for (let i = 0; i < wecodeData.length; i++) {
          if (wecodeData[i].require) {
            if (wecodeData[i].value === "") {
              message.error("必填项不能为空", 2);
              return;
            }
          }
          if (wecodeData[i].isShowError) {
            message.error(
              wecodeData[i].title + "所填信息不符合格式,请检查后重新填写",
              2
            );
            return;
          }
        }
        setFlag(false);
        let batchId = uploadStatus ? "" : wecodeData[0].batchId;
        if (uploadStatus) {
          let arr = getItemByKey(wecodeData, "icon")?.value.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          let dataFile = new Blob([u8arr]);
          let formData = new FormData();
          formData.append("file0", dataFile, "1.png");
          fetch(
            `/${process.env.REACT_APP_API_CONTEXT}/service/myAppService/uploadImage?type=icon`,
            {
              method: "POST",
              body: formData
            }
          ).then(data => {
            if (data.status == 1) {
              let result = (data && data.data) || {};
              setItemByKey(wecodeData, "icon", { value: result.showUrl });
              editApp1(result.batchId);
            } else {
              message.error(data.errMsg || "图片上传失败", 2);
              return false;
            }
          });
        } else {
          editApp1(batchId);
        }

        break;
      case 1:
        break;
      case 2:
        setVisible(true);
        setVisibleCancle(true);
        break;
      default:
        break;
    }
    return;
  };
  const judementStatus = isRelease => {
    // status表示是否已经上架
    if (edit === "0") {
      // 查看页面
      getAppInfoApi("0", isRelease);
    } else {
      // 编辑页面
      getAppInfoApi("1");
    }
  };
  const editApp1 = batchId => {
    let obj = {
      batchId: batchId,
      nameCn: getItemByKey(wecodeData, "nameCn")?.value,
      nameEn: getItemByKey(wecodeData, "nameEn")?.value,
      descCn: getItemByKey(wecodeData, "descCn")?.value,
      descEn: getItemByKey(wecodeData, "descEn")?.value,
      supportInfo: getItemByKey(wecodeData, "supportInfo")?.value,
      keywords: getItemByKey(wecodeData, "keywords")?.value,
      serviceFrom: getItemByKey(wecodeData, "serviceFrom")?.value,
      privacyLinkCn: getItemByKey(wecodeData, "privacyLinkCn")?.value,
      privacyLinkEn: getItemByKey(wecodeData, "privacyLinkEn")?.value
    };
    if (/[&'\"<>]/g.test(obj.descCn) || /\|\s*cmd/g.test(obj.descCn)) {
      message.error("中文简介中不应出现& ' \" < >或者|cmd等特殊字符", 2);
      return;
    }
    if (/[&'\"<>]/g.test(obj.descEn) || /\|\s*cmd/g.test(obj.descEn)) {
      message.error("英文简介中不应出现& ' \" < >或者|cmd等特殊字符", 2);
      return;
    }
    if (/[&'\"<>]/g.test(obj.supportInfo)) {
      message.error("用户支持中不应出现& ' \" < >等特殊字符", 2);
      return;
    }
    if (/[&'\"<>]/g.test(obj.keywords)) {
      message.error("关键词中不应出现& ' \" < >等特殊字符", 2);
      return;
    }
    editApp(id, obj, getAppPathFromType(paramsType))
      .then(data => {
        if (data.status == "1") {
          getAppInfoList(id, getAppPathFromType(paramsType)).then(data => {
            dispatch(actions.setAppInfo(data.data));
            localStorage.setItem("appInfo", JSON.stringify(data.data));
            history.push(`${urlPrefix}/baseInfo?id=${id}&type=${type}`);
          });
        } else {
          message.error(data.errMsg || data.msg, 2);
        }
      })
      .catch(error => {});
  };
  useEffect(() => {
    handleChangeFlag();
    if (backNoFresh) {
      return;
    } else {
      getAppRole(id, getAppPathFromType(paramsType)).then(result => {
        if (result.status === 1) {
          setRole(result.data);
        } else {
          dispatch(actions.setAppInfo({ appName: "", aliasName: "" }));
          localStorage.setItem(
            "appInfo",
            JSON.stringify({ appName: "", aliasName: "" })
          );
          history.push(`/${type}/wecode-v2`);
          return;
        }
      });
    }

    if (paramsType === APP_TYPE.isv) {
      appOnshelfStatus(id)
        .then(result => {
          if (result.status == "1") {
            // 是否上架
            let isRelease = result.data;
            setIsOnshelf(isRelease);
            judementStatus(isRelease);
          } else {
            message.error(result.errMsg, 2);
          }
        })
        .catch(error => {});
    } else {
      judementStatus();
    }
  }, [routeFlag, backNoFresh]);

  const handleChangeFlag = async () => {
    setBackNoFresh(true);
    if (routeFlag) {
      let visibleCancle1 = !visibleCancle;
      await setVisible(true);
      await setVisibleCancle(true);
      if (!visibleCancle1) {
        return true;
      } else {
        return false;
      }
    }
  };

  // 如果上架,则增加华为云返回的信息
  const getIsvReleaseItems = result => {
    const Items = [
      {
        require: false, // 版本
        isEdit: false,
        type: 3,
        title: "应用主图和视频",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        errorTip: "",
        value: result.multimedia || [],
        maxlength: 300
      },
      {
        require: false, //
        isEdit: false,
        type: 2,
        title: "应用简介",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        errorTip: "",
        value: result.summary || blankWord,
        maxlength: 300
      },
      {
        require: false, // 应用
        isEdit: false,
        type: 2,
        title: "应用说明",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        canFolded: true,
        errorTip: "",
        value: result.description || blankWord,
        maxlength: 300
      },
      {
        require: false, // 应用亮点
        isEdit: false,
        type: 2,
        title: "应用亮点",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        errorTip: "",
        value: (result.highlights && result.highlights.join(" ")) || blankWord,
        maxlength: 300
      },
      {
        require: false, // 客服邮箱
        isEdit: false,
        type: 2,
        title: "客服支持",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        errorTip: "",
        value: result.supportInfo || blankWord,
        maxlength: 300
      },
      {
        require: false, // 应用上架地址
        isEdit: false,
        type: 2,
        title: "应用上架地址",
        placeholder: text.CnIntroduce.placeholder,
        tip: "",
        isShowError: false,
        errorTip: "",
        value: result.productUrl || blankWord,
        maxlength: 300
      }
    ];
    return Items;
  };

  const getValue = (value, edit) => {
    return value || (edit == 1 ? "" : blankWord);
  };

  /**
   *
   * @param {是否在编辑} edit
   * @param {是否上架} isRelease
   */
  const getAppInfoApi = (edit, isRelease) => {
    // status默认表示没上架
    getAppInfoList(id, getAppPathFromType(paramsType)).then(data => {
      if (data.status == "1") {
        let result = null;
        result = data.data;
        setAppName(result.nameCn);
        let temWeData = wecodeData;
        // 内部应用
        const appType1 = /^(weh5.)/g.test(result.aliasName)
          ? "原生we码"
          : "普通we码";
        setItemByKey(temWeData, "icon", {
          value: urlDomainDeal((result.icon && result.icon.showUrl) || ""),
          batchId: urlDomainDeal((result.icon && result.icon.batchId) || ""),
          aliasName: result.aliasName,
          secret: result.secret
        });
        setItemByKey(temWeData, "nameCn", {
          value: getValue(result.nameCn, edit)
        });
        setItemByKey(temWeData, "nameEn", {
          value: getValue(result.nameEn, edit)
        });
        setItemByKey(temWeData, "getAppType", {
          isEdit: false,
          value: appType1
        });
        setItemByKey(temWeData, "aliasName", {
          value: getValue(result.aliasName, edit)
        });
        setItemByKey(temWeData, "secret", {
          value: getValue(result.secret, edit)
        });
        setItemByKey(temWeData, "descCn", {
          value: getValue(result.descCn, edit)
        });
        setItemByKey(temWeData, "descEn", {
          value: getValue(result.descEn, edit)
        });
        setItemByKey(temWeData, "supportInfo", {
          value: getValue(result.supportInfo, edit)
        });
        setItemByKey(temWeData, "keywords", {
          value: getValue(result.keywords, edit)
        });
        setItemByKey(temWeData, "serviceFrom", {
          value: getValue(result.serviceFrom, edit)
        });
        setItemByKey(temWeData, "privacyLinkCn", {
          value: getValue(result.privacyLinkCn, edit)
        });
        setItemByKey(temWeData, "privacyLinkEn", {
          value: getValue(result.privacyLinkEn, edit)
        });
        let arr = [];
        if (edit == "1") {
          setIsEdit(true);
          temWeData.forEach(item => {
            item.isEdit = true;
            arr.push(item);
          });
        }
        let isvReleaseAppInfo = [];
        if (paramsType === APP_TYPE.isv && isRelease) {
          isvReleaseAppInfo = getIsvReleaseItems(result);
        }
        arr = [...temWeData, ...isvReleaseAppInfo];
        setWeCodeData([...arr]);
      } else {
        message.error(data.msg || data.errMsg, 1);
      }
    });
  };

  const showDelete = () => {
    setVisible(true);
    setVisibleDelete(true);
  };
  const change = (value, index) => {
    let reg = null;
    wecodeData[index].isShowError = false;
    const changeItem = wecodeData[index];
    const { key } = changeItem || {};
    if (index === 1) {
      reg = /^[\u4E00-\u9FA5a-zA-Z0-9&|、_-]{2,20}$/;
      if (value && !reg.test(value)) {
        wecodeData[index].isShowError = true;
      }
    } else if (index === 2) {
      reg = reg = /^[a-zA-Z0-9&|、\s_-]{2,50}$/;
      if (value && !reg.test(value)) {
        wecodeData[index].isShowError = true;
      }
    } else if (index === 0) {
      if (!value.batchId) {
        value = value;
        setuploadStatus(true);
      } else {
        wecodeData[index].batchId = value.batchId;
        value = value.showUrl;
        setuploadStatus(false);
      }
    }

    // 网址校验
    if (
      key === "serviceFrom" ||
      key === "privacyLinkCn" ||
      key === "privacyLinkEn"
    ) {
      let reg = /^(http|https):\/\/([\w.]+\/?)\S*/gi;
      let bool = reg.test(value);
      wecodeData[index].isShowError = !bool;
    }
    wecodeData[index].value = value;
    setWeCodeData([...wecodeData]);
  };

  const enbleDelete = async () => {
    dispatch(actions.routeFlag(false));
    setVisible(false);
    if (visibleDelete) {
      if (inputValue !== appName) {
        message.error("输入有误，请重新输入", 2);
        return;
      }
      deleteApp(id, getAppPathFromType(paramsType)).then(result => {
        setVisible(false);
        setVisibleDelete(false);
        if (result.status === 0) {
          message.error(result.errMsg, 2);
        } else {
          history.push(`/${paramsType}/wecode-v2`);
        }
      });
    }
    if (visibleCancle) {
      setVisibleCancle(false);
      if (changeRouter) {
        if (leaveStatus) {
          history.push(leaveStatus);
        } else {
          let newUrl = window.location.href.replace(
            history.location.pathname,
            changeRouter.split("#")[1]
          );
          let newUrl1 = newUrl
            .replace(history.location.search, "")
            .split("#")[1];
          history.push(newUrl1);
        }
      } else {
        if (leaveStatus) {
          history.push(leaveStatus);
        } else {
          history.push(`${urlPrefix}/baseInfo?id=${id}`);
        }
      }
    }

    if (visibelReset) {
      resetSecret({ id }, getAppPathFromType(paramsType)).then(result => {
        if (result.status == 1) {
          setVisible(false);
          setVisibleReset(false);
          let newSecret = result.data;
          let secretItem = wecodeData.find(item => {
            return item.title === "client_secret";
          });
          if (secretItem) {
            secretItem.value = newSecret;
          }
          setWeCodeData([...wecodeData]);
          message.success("重置成功！", 2);
        } else {
          message.error(result.errMsg, 2);
        }
      });
    }
    setVisible(false);
    setVisibleDelete(false);
    setVisibleCancle(false);
    setVisibleReset(false);
  };
  const cancelDelete = () => {
    setVisible(false);
    setVisibleDelete(false);
    setVisibleCancle(false);
    setVisibleReset(false);
    dispatch(actions.routeFlag(false));
  };

  const changeInpt = event => {
    event.persist();
    setInputValue(event.target.value);
  };

  const resetSecretEvent = index => {
    setVisibleReset(true);
    setVisible(true);
  };
  const titleStatus = () => {
    if (visibleDelete) {
      return "确认删除";
    } else if (visibleCancle) {
      return "确认取消";
    } else if (visibelReset) {
      return "确认重置 ";
    } else {
      return "确认删除";
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        {
          <>
            <div className="wecode-body wecode-baseinfo">
              <VersionTip
                style={{ marginLeft: "24px", marginBottom: "29px" }}
              ></VersionTip>
              <p className="baseinf-title">基础信息</p>
              {wecodeData.map((item, index) => {
                return (
                  <Assembly
                    key={index}
                    item={item}
                    resetSecret={() => resetSecretEvent(index)}
                    isRole={role === 1 || user.isAdmin}
                    change={event => change(event, index)}
                    disPlay={null}
                  />
                );
              })}
              {!isEdit && (role === 1 || user.isAdmin) && (
                <div className="wecode-button">
                  <Button onClick={editBaseInfo}>
                    {isOnshelf
                      ? user.isAdmin
                        ? "前往华为云修改"
                        : "联系管理员修改"
                      : "修改"}
                  </Button>
                  {!isOnshelf && <Button onClick={showDelete}>删除</Button>}
                </div>
              )}
              {isEdit ? (
                <div className="wecode-handles">
                  <Button onClick={() => editHandle(0)}>保存</Button>
                  <Button onClick={() => editHandle(2)}>取消</Button>
                </div>
              ) : (
                ""
              )}
            </div>
            <Prompt
              message={location => {
                if (isEdit == 1 && flag) {
                  let url = location.pathname + location.search;
                  let visibleCancle1 = !visibleCancle;
                  setVisible(true);
                  setVisibleCancle(true);
                  setleaveStatus(url);
                  if (!visibleCancle1) {
                    return true;
                  } else {
                    return false;
                  }
                }
              }}
            ></Prompt>
          </>
        }
        <>
          {visible && (
            <Modal
              maskClosable={false}
              width={600}
              centered
              title={titleStatus()}
              visible={visible}
              onOk={() => enbleDelete()}
              onCancel={() => {
                cancelDelete();
              }}
            >
              {visibleDelete && (
                <div className="modal-content">
                  <div className="apname-desc">
                    应用删除后不可恢复，请慎重，如果应用已经上线，则在删除前确保已告诉用户个人数据处理方案
                  </div>
                  <div className="appname-check">
                    <span>请输入应用名称</span>
                    <Input
                      placeholder="请输入"
                      defaultValue={inputValue}
                      value={inputValue}
                      onChange={changeInpt}
                    />
                  </div>
                </div>
              )}
              {visibleCancle && (
                <div className="modal-content">
                  点击确定按钮后，当前页面未保存的信息将会丢失
                </div>
              )}
              {visibelReset && (
                <div className="modal-content">
                  重置client_secret会导致之前的client_secret失效，请谨慎操作
                </div>
              )}
            </Modal>
          )}
        </>

        <>
          {/* 联系管理员上架对话框 */}
          <Modal
            destroyOnClose={true}
            maskClosable={false}
            title="联系管理员修改"
            visible={adminListModalVisible}
            width={600}
            centered={true}
            onCancel={() => {
              setAdminListModalVisible(false);
            }}
            style={{ position: "relative" }}
            footer={
              <Button
                type="primary"
                onClick={() => {
                  setAdminListModalVisible(false);
                }}
              >
                关闭
              </Button>
            }
          >
            <div className="administrator-list">
              {administratorList.length > 0 ? (
                <ul>
                  {administratorList.map((item, index) => (
                    <li key={index}>
                      <label>{item.chineseName}</label>
                      <label>{item.mobileCodeAll}</label>
                      <label>{item.personMail}</label>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>未获取到管理员列表</p>
              )}
            </div>
          </Modal>
        </>
      </div>
    </>
  );
};
